(function () {
  const imgUrl = window.EUPHORIA_CURSOR_IMAGE;

  if (!imgUrl) {
    console.warn("EUPHORIA_CURSOR_IMAGE is missing.");
    return;
  }

  if (!window.matchMedia("(pointer: fine)").matches) return;

  const cursor = document.createElement("div");
  cursor.id = "euphoria-custom-cursor";

  const img = document.createElement("img");
  img.src = imgUrl;
  img.alt = "";
  img.draggable = false;

  cursor.appendChild(img);
  document.body.appendChild(cursor);

  const style = document.createElement("style");
  style.textContent = `
    html, body,
    a, button, input, textarea, select, label,
    [role="button"], summary {
      cursor: none !important;
    }

    #euphoria-custom-cursor {
      position: fixed;
      left: 0;
      top: 0;
      width: 75px;
      height: 75px;
      pointer-events: none;
      z-index: 2147483647;
      transform: translate3d(-9999px, -9999px, 0);
      transition: width .16s ease, height .16s ease, opacity .18s ease;
      opacity: 0;
      will-change: transform, width, height;
    }

    #euphoria-custom-cursor img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      user-select: none;
      -webkit-user-drag: none;
      filter: drop-shadow(0 4px 5px rgba(60, 40, 25, .22));
      transform: rotate(-8deg);
      transition: transform .16s ease, filter .16s ease;
    }

    #euphoria-custom-cursor.is-hover {
      width: 85px;
      height: 85px;
    }

    #euphoria-custom-cursor.is-hover img {
      transform: rotate(-4deg) scale(1.03);
      filter: drop-shadow(0 5px 8px rgba(60, 40, 25, .28));
    }

    #euphoria-custom-cursor.is-down {
      width: 70px;
      height: 70px;
    }

    #euphoria-custom-cursor.is-down img {
      transform: rotate(-12deg) scale(.96);
    }
  `;

  document.head.appendChild(style);

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let currentX = mouseX;
  let currentY = mouseY;
  let vx = 0;
let vy = 0;
  window.euphoriaCursor = {
  x: currentX,
  y: currentY
};
  let visible = false;

  const tipOffsetX = 16;
  const tipOffsetY = 64;

  function isClickable(el) {
    return !!el.closest(
      'a, button, input, textarea, select, label, summary, [role="button"], [onclick], .button, .btn, .shopify-payment-button'
    );
  }

  function updateHoverState(target) {
    if (isClickable(target)) {
      cursor.classList.add("is-hover");
    } else {
      cursor.classList.remove("is-hover");
    }
  }

  document.addEventListener("mousemove", function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;

    if (!visible) {
      visible = true;
      cursor.style.opacity = "1";
      currentX = mouseX;
      currentY = mouseY;
    }

    updateHoverState(e.target);
  }, { passive: true });

  document.addEventListener("mouseover", function (e) {
    updateHoverState(e.target);
  }, { passive: true });

  document.addEventListener("mouseleave", function () {
    cursor.style.opacity = "0";
    visible = false;
  });

  document.addEventListener("mouseenter", function () {
    cursor.style.opacity = "1";
    visible = true;
  });

  document.addEventListener("mousedown", function () {
    cursor.classList.add("is-down");
  });

  document.addEventListener("mouseup", function () {
    cursor.classList.remove("is-down");
  });

  function animate() {
    const spring = 0.035;   // 引っ張る力。大きいほど追いつく
const friction = 0.76; // 摩擦。小さいほどすぐ止まる

vx += (mouseX - currentX) * spring;
vy += (mouseY - currentY) * spring;

vx *= friction;
vy *= friction;

currentX += vx;
currentY += vy;
    window.euphoriaCursor.x = currentX;
window.euphoriaCursor.y = currentY;

    cursor.style.transform =
      "translate3d(" +
      (currentX - tipOffsetX) +
      "px, " +
      (currentY - tipOffsetY) +
      "px, 0)";

    requestAnimationFrame(animate);
  }

  animate();
})();



(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const assets = window.EUPHORIA_MUSIC_ASSETS;
    if (!assets) return;

    

    const CONFIG = {
      scale: 1.6,
      left: 35,
      bottom: 165,
      mobileScale: 1.25,
      mobileLeft: 8,
      mobileBottom: 118,
      videoFadeDelay: 550,
      vanishAfter: 2200,
      removeAfter: 3500
    };

    const video = document.querySelector("video");
    if (!video) return;

    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.play().catch(() => {});

    const clickSound = new Audio(assets.clickSound);
    clickSound.preload = "auto";
    clickSound.volume = 1;

    const ui = document.createElement("div");
    ui.id = "eup-sound-ui";

    ui.innerHTML = `
      <img id="eup-light" src="${assets.light}" alt="">

      <img class="eup-drift eup-drift-2" src="${assets.sparkle1}" alt="">
      <img class="eup-drift eup-drift-3" src="${assets.sparkle3}" alt="">

      <img id="eup-box-closed" class="eup-box" src="${assets.closed}" alt="">
      <img id="eup-box-open" class="eup-box" src="${assets.open}" alt="">

      <img class="eup-drift eup-drift-1" src="${assets.sparkle2}" alt="">
      <img class="eup-drift eup-drift-4" src="${assets.sparkle4}" alt="">

      <img id="eup-note" src="${assets.note}" alt="">
      <img id="eup-click" src="${assets.click}" alt="Click me">
    `;

    document.body.appendChild(ui);

    const closed = document.getElementById("eup-box-closed");
    const open = document.getElementById("eup-box-open");
    const light = document.getElementById("eup-light");
    const note = document.getElementById("eup-note");
    const click = document.getElementById("eup-click");

    const style = document.createElement("style");
    style.textContent = `
      #eup-sound-ui {
        --eup-scale: ${CONFIG.scale};
        position: fixed;
        left: ${CONFIG.left}px;
        bottom: ${CONFIG.bottom}px;
        width: calc(210px * var(--eup-scale));
        height: calc(155px * var(--eup-scale));
        z-index: 999999;
        cursor: pointer;
        transform-origin: left bottom;
        animation: eupIdleFloat 4s ease-in-out infinite;
        transition: transform .35s ease, opacity 1.2s ease, filter .35s ease;
      }

      #eup-sound-ui:hover {
        transform: scale(1.05);
        filter: drop-shadow(0 0 18px rgba(255,235,190,.8));
      }

      #eup-sound-ui.opening {
        animation: eupOpenBump .45s ease-out forwards;
      }

      #eup-light {
        position: absolute;
        left: calc(-24px * var(--eup-scale));
        bottom: calc(-35px * var(--eup-scale));
        width: calc(150px * var(--eup-scale));
        opacity: 0;
        pointer-events: none;
        mix-blend-mode: screen;
        z-index: 0;
      }

      #eup-light.show {
        animation: eupLightBloom 1.8s ease-out forwards;
      }

      .eup-box {
        position: absolute;
        left: 0;
        bottom: 0;
        width: calc(86px * var(--eup-scale));
        pointer-events: none;
        transition: opacity .25s ease, transform .45s ease;
        filter: drop-shadow(0 0 12px rgba(255,235,190,.45));
        z-index: 3;
      }

      #eup-box-open {
        opacity: 0;
        transform: scale(.96);
      }

      #eup-box-closed.hide {
        opacity: 0;
        transform: scale(.96);
      }

      #eup-box-open.show {
        opacity: 1;
        transform: scale(1);
      }

      .eup-drift {
        position: absolute;
        pointer-events: none;
        mix-blend-mode: screen;
        filter: drop-shadow(0 0 8px rgba(255,235,190,.7));
      }

      .eup-drift-1 {
        left: calc(-45px * var(--eup-scale));
        bottom: calc(-64px * var(--eup-scale));
        width: calc(200px * var(--eup-scale));
        opacity: .76;
        animation: eupDriftTwo 6.2s ease-in-out infinite;
        z-index: 5;
      }

      .eup-drift-2 {
        left: calc(-75px * var(--eup-scale));
        bottom: calc(-65px * var(--eup-scale));
        width: calc(280px * var(--eup-scale));
        opacity: .99;
        animation: eupDriftOne 5.2s ease-in-out infinite;
        z-index: 1;
      }

      .eup-drift-3 {
        left: calc(-2px * var(--eup-scale));
        bottom: calc(42px * var(--eup-scale));
        width: calc(150px * var(--eup-scale));
        opacity: .85;
        animation: eupDriftThree 7s ease-in-out infinite;
        z-index: 1;
      }

      .eup-drift-4 {
        left: calc(18px * var(--eup-scale));
        bottom: calc(-8px * var(--eup-scale));
        width: calc(130px * var(--eup-scale));
        opacity: .75;
        animation: eupDriftFour 7.5s ease-in-out infinite;
        z-index: 5;
      }

      #eup-note {
        position: absolute;
        left: calc(62px * var(--eup-scale));
        bottom: calc(76px * var(--eup-scale));
        width: calc(48px * var(--eup-scale));
        opacity: 0;
        pointer-events: none;
        filter: drop-shadow(0 0 12px rgba(255,235,190,.95));
        z-index: 6;
      }

      #eup-note.show {
        animation: eupNoteRise 3.55s ease-out forwards;
      }

      #eup-click {
        position: absolute;
        left: calc(72px * var(--eup-scale));
        bottom: calc(-60px * var(--eup-scale));
        width: calc(110px * var(--eup-scale));
        pointer-events: none;
        opacity: .92;
        mix-blend-mode: screen;
        filter: drop-shadow(0 0 10px rgba(255,235,190,.75));
        animation: eupClickFloat 2.8s ease-in-out infinite;
        transition: opacity .45s ease, transform .45s ease;
        z-index: 6;
      }

      #eup-click.hide {
        opacity: 0;
        transform: translateY(-8px) scale(.95);
      }

      .eup-burst {
        position: absolute;
        width: calc(84px * var(--eup-scale));
        pointer-events: none;
        mix-blend-mode: screen;
        animation: eupBurst 1.55s ease-out forwards;
        z-index: 7;
      }

      #eup-sound-ui.vanish {
        opacity: 0;
        transform: translateY(14px) scale(.88);
        pointer-events: none;
      }

      @keyframes eupIdleFloat {
        0%, 100% { translate: 0 0; }
        50% { translate: 0 -5px; }
      }

      @keyframes eupOpenBump {
        0% { transform: scale(1.05) rotate(0deg); }
        35% { transform: scale(1.1) rotate(-2deg); }
        100% { transform: scale(1) rotate(0deg); }
      }

      @keyframes eupClickFloat {
        0%, 100% { opacity: .78; transform: translateY(0); }
        50% { opacity: 1; transform: translateY(-4px); }
      }

      @keyframes eupLightBloom {
        0% { opacity: 0; transform: scale(.35) translateY(12px); }
        24% { opacity: 1; transform: scale(1.08) translateY(0); }
        100% { opacity: 0; transform: scale(1.55) translateY(-20px); }
      }

      @keyframes eupNoteRise {
        0% { opacity: 0; transform: translate(0,10px) rotate(-10deg) scale(.75); }
        18% { opacity: 1; }
        100% { opacity: 0; transform: translate(30px,-58px) rotate(12deg) scale(1.18); }
      }

      @keyframes eupDriftOne {
        0%,100% { opacity: .22; transform: translate(0,0) scale(.8) rotate(0deg); }
        50% { opacity: .75; transform: translate(12px,-20px) scale(1.05) rotate(5deg); }
      }

      @keyframes eupDriftTwo {
        0%,100% { opacity: .18; transform: translate(0,0) scale(.85) rotate(0deg); }
        50% { opacity: .65; transform: translate(20px,-5px) scale(1.08) rotate(-6deg); }
      }

      @keyframes eupDriftThree {
        0%,100% { opacity: .18; transform: translate(0,0) scale(.8); }
        50% { opacity: .6; transform: translate(14px,-26px) scale(1.1); }
      }

      @keyframes eupDriftFour {
        0%,100% { opacity: .30; transform: translate(0,0) scale(.9) rotate(0deg); }
        50% { opacity: .72; transform: translate(10px,-12px) scale(1.08) rotate(-6deg); }
      }

      @keyframes eupBurst {
        0% { opacity: .95; transform: translate(0,0) rotate(0deg) scale(.45); }
        100% { opacity: 0; transform: translate(var(--x), var(--y)) rotate(var(--r)) scale(1.2); }
      }

      @media screen and (max-width: 749px) {
        #eup-sound-ui {
          --eup-scale: ${CONFIG.mobileScale};
          left: ${CONFIG.mobileLeft}px;
          bottom: ${CONFIG.mobileBottom}px;
        }
      }
    `;
    document.head.appendChild(style);

    function burstSparkles() {
      for (let i = 0; i < 24; i++) {
        const img = document.createElement("img");
        img.src = assets.sparkle2;
        img.className = "eup-burst";

        const angle = Math.random() * Math.PI * 2;
        const dist = 45 + Math.random() * 140;

        img.style.setProperty("--x", Math.cos(angle) * dist + "px");
        img.style.setProperty("--y", Math.sin(angle) * dist + "px");
        img.style.setProperty("--r", (Math.random() * 60 - 30) + "deg");

        img.style.left = "28px";
        img.style.bottom = "28px";

        ui.appendChild(img);
        setTimeout(() => img.remove(), 1600);
      }
    }

    function fadeInVideo() {
      video.muted = false;
      video.volume = 0;
      video.play().catch(() => {});

      let volume = 0;
      const fade = setInterval(() => {
        volume += 0.012;
        video.volume = Math.min(volume, 1);
        if (volume >= 1) clearInterval(fade);
      }, 80);
    }

    ui.addEventListener("click", function () {
      clickSound.currentTime = 0;
      clickSound.play().catch(() => {});

      ui.classList.add("opening");
      click.classList.add("hide");

      setTimeout(() => {
        closed.classList.add("hide");
        open.classList.add("show");
      }, 150);

      setTimeout(() => {
        light.classList.add("show");
        burstSparkles();
      }, 220);

      setTimeout(() => {
        note.classList.add("show");
      }, 380);

      setTimeout(() => {
        fadeInVideo();
      }, CONFIG.videoFadeDelay);

      setTimeout(() => {
        ui.classList.add("vanish");
      }, CONFIG.vanishAfter);

      setTimeout(() => {
        ui.remove();
      }, CONFIG.removeAfter);
    }, { once: true });
  });
})();